import React, { useState } from 'react';
import PropType from 'prop-types';
import DataTable from 'react-data-table-component';

import useTemplates from 'components/Common/Templates/Hooks/useTemplatesList';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';
import SummaryModal from './SummaryModal';

export default function Table({ enterpriseId }) {
  const [templates, refetch] = useTemplates(enterpriseId);
  const [keyword, setKeyword] = useState('');
  const [filterType, setFilterType] = useState(null);
  const [filterEnterprise, setFilterEnterprise] = useState(null);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [programStatuses, setProgramStatuses] = useState([]);

  const onClose = (statuses) => {
    setProgramStatuses(statuses);
    setShowSummaryModal(true);
    refetch();
  };

  return (
    <>
      <Filters
        enterpriseId={enterpriseId}
        keyword={keyword}
        setKeyword={setKeyword}
        filterType={filterType}
        setFilterType={setFilterType}
        filterEnterprise={filterEnterprise}
        setFilterEnterprise={setFilterEnterprise}
      />

      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns({ enterpriseId, onClose })}
          data={data(templates, keyword, filterType, filterEnterprise)}
          noDataComponent={(
            <div className="mt20">
              {templates == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>

      <SummaryModal
        programStatuses={programStatuses}
        show={showSummaryModal}
        onHide={() => setShowSummaryModal(false)}
      />
    </>
  );
}

Table.propTypes = {
  enterpriseId: PropType.number,
};

Table.defaultProps = {
  enterpriseId: null,
};
